import React, { useEffect, useState } from "react";
import { Button, Card, Form, Row, Col, Spinner, Image } from "react-bootstrap";
import { useGetSaathiFLEQuery } from "features/CrmDashboardComp/CmrApiSlice";
import { useGetFPOListQuery } from "features/onboarding/organizations/FarmersGroup/FPO/FPOApiSlice";
import { useGetCBBOListQuery } from "features/onboarding/organizations/FarmersGroup/CBBO/CBBOApiSlice";
import { useGetFarmersQuery } from "./farmerApiSlice";
import { DataGrid } from "@mui/x-data-grid";
import StateDistrict from "./StateDistrict";
import CustomSearchBar from "components/CustomSearchBar";
import Swal from "sweetalert2";
import {
  useUploadFarmerFromTableMutation,
  useOrganizationAssignMutation,
} from "./farmerApiSlice";
import Pagination from "@mui/material/Pagination";

// const STORAGE_KEY = "selectedFarmerIds";

export const AssignFarmersBulk = ({ setAssignOption, orgId }) => {
  const [selectedRole, setSelectedRole] = useState("Saathi");
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedFarmerIds, setSelectedFarmerIds] = useState([]);
  //    useState(() => {
  //     const saved = localStorage.getItem(STORAGE_KEY);
  //     return saved ? JSON.parse(saved) : [];
  //   });
  //   const [submittedFarmers, setSubmittedFarmers] = useState(() => {
  //     const saved = localStorage.getItem("selectedFarmersDetails");
  //     return saved ? JSON.parse(saved) : [];
  //   });
  //   const [showConfirmation, setShowConfirmation] = useState(false);
  const [state_id, setStateId] = useState("");
  const [district_id, setDistrictId] = useState("");
  const [block_id, setBlockId] = useState("");
  const [stateName, setStateName] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [blockName, setBlockName] = useState("");
  const [blockList, setBlockList] = useState([]);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [farmerRows, setfarmerRows] = useState([]);
  const [uploadSaathiFarmers] = useUploadFarmerFromTableMutation();
  const [organizationAssign] = useOrganizationAssignMutation();
  const [pagination, setPagination] = useState({
    page: 1,
    pageCount: 0,
    per_page: 50,
  });
  const { data: saathiData, isLoading: saathiLoading } = useGetSaathiFLEQuery(
    {districtId:"",searchKey:""},
    { skip: selectedRole !== "Saathi" }
  );
  const { data: fpoData, isLoading: fpoLoading } = useGetFPOListQuery(
    { pagination: "", searchKey: "", orgId: "" },
    { skip: selectedRole !== "FPO" }
  );
  const { data: cbboData, isLoading: cbboLoading } = useGetCBBOListQuery(
    { pagination: "", searchKey: "" },
    { skip: selectedRole !== "CBBO" }
  );
  const { data: farmerData, isLoading: farmerLoading } = useGetFarmersQuery(
    {
      page: pagination.page,
      per_page: pagination.per_page,
      orgId,
      stateId: state_id,
      districtId: district_id,
      searchKey: debouncedSearch || "",
    },
    { refetchOnMountOrArgChange: true }
  );

  const getUserList = () => {
    switch (selectedRole) {
      case "Saathi":
        return saathiData?.data?.results || [];
      case "FPO":
        return fpoData?.data?.results || [];
      case "CBBO":
        return cbboData?.data?.results || [];
      default:
        return [];
    }
  };

  const userList = getUserList();
  useEffect(() => {
    const paginationFromApi = farmerData?.data?.pages
      ? {
          page: farmerData?.data?.current_page,
          pageCount: farmerData?.data?.pages,
          per_page: farmerData?.data?.per_page,
        }
      : pagination;
    setPagination(paginationFromApi);
    setfarmerRows(farmerData?.data?.results ? farmerData?.data?.results : []);
  }, [farmerData]);

  const columns = [
    { field: "full_name", headerName: "Name", width: 150 },
    {
      field: "created_at",
      headerName: "Onboarding Date",
      width: 150,
      renderCell: (cellvalues) => cellvalues.row.created_at?.slice(0, 10) || "",
    },
    { field: "phone_number", headerName: "Mobile", width: 120 },
    { field: "gender", headerName: "Gender", width: 80 },
    { field: "age", headerName: "Age", width: 50 },
    {
      field: "farmer_category",
      headerName: "Category",
      width: 200,
      renderCell: ({ row }) => (
        <div style={{ fontSize: "14px" }} title={row.farmer_category}>
          {(row.farmer_category || "").length > 50
            ? `${row.farmer_category.substring(0, 50)}...`
            : row.farmer_category}
        </div>
      ),
    },
    {
      field: "total_land_holding",
      headerName: "Declared Landholding",
      width: 110,
      renderCell: ({ row }) =>
        `${row.total_land_holding} ${row.unit_of_land_holding || ""}`,
    },
    {
      field: "total_acs",
      headerName: "ACS",
      width: 100,
      renderCell: ({ row }) => row.total_acs?.toFixed(2),
    },
    { field: "state_name", headerName: "State Name", width: 130 },
    {
      field: "district_name",
      headerName: "District Name",
      width: 140,
      renderCell: ({ row }) => (
        <div style={{ fontSize: "13px" }} title={row.district_name}>
          {(row.district_name || "").length > 50
            ? `${row.district_name.substring(0, 50)}...`
            : row.district_name}
        </div>
      ),
    },
  ];

  const onLocationChange = (event) => {
    if (event.ConditionName === "state") {
      setBlockId("");
      setDistrictName("");
      setDistrictId("");
      setBlockName("");
      setBlockList([]);
      setStateId(event.value);
      setStateName(event.label);
    }
    if (event.ConditionName === "district") {
      setDistrictId(event.value);
      setDistrictName(event.label);
      setBlockId("");
      setBlockName("");
    }
    if (event.ConditionName === "block") {
      setBlockId(event.value);
      setBlockName(event.label);
    }
    setPagination({page: 1,pageCount: 0,per_page:50});
  }

  const handleSubmit = async () => {
    if (!selectedRole || !selectedUser) {
      Swal.fire({
        title: `Select ${selectedRole}`,
        text: `Please select ${selectedRole} and Farmers.`,
        icon: "warning",
        confirmButtonText: "Continue",
      });
      return;
    }

    const selectedFarmers = farmerRows.filter((f) =>
      selectedFarmerIds.includes(f.id)
    );

    if (selectedFarmers.length === 0) {
      Swal.fire({
        title: "Select Farmers",
        text: "Please select Farmers to Assign.",
        icon: "warning",
        confirmButtonText: "Continue",
      });
      return;
    }
    await handleFinalSubmit();

    // setSubmittedFarmers(selectedFarmers);

    // setShowConfirmation(true);
  };

  const handleFinalSubmit = () => {
    if (selectedRole === "Saathi") {
      let sendPayload = {
        agent_id: selectedUser.id,
        assign_farmers: selectedFarmerIds,
      };
      uploadSaathiFarmers({ payload: sendPayload })
        .unwrap()
        .then((data) => {
          Swal.fire({
            title: "Success!",
            text: "Farmers assigned successfully.",
            icon: "success",
          });
        })
        .catch((error) => {
          return;
        });
    } else {
      let sendPayload = {
        organization_id: selectedUser.id,
        farmer_id_list: selectedFarmerIds,
      };
      organizationAssign(sendPayload)
        .unwrap()
        .then((data) => {
          Swal.fire({
            title: "Success!",
            text: "Farmers assigned successfully.",
            icon: "success",
          });
        })
        .catch((error) => {
          return;
        });
    }

    // localStorage.removeItem(STORAGE_KEY);
    // localStorage.removeItem("selectedFarmersDetails");
    // setShowConfirmation(false);
    setSelectedUser(null);
    setSelectedFarmerIds([]);
    setAssignOption(false);

    // setSubmittedFarmers([]);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchKey.trim() ? searchKey : "");
    }, 500);
    return () => clearTimeout(handler);
  }, [searchKey]);

  const handleChangeSearch = (value) => {
    setSearchKey(value);
    setPagination({page: 1,pageCount: 0,per_page:50});

  };

  // useEffect(() => {
  //   if (selectedFarmerIds.length > 0) {
  //     const selectedFarmers = farmerRows?.filter((f) =>
  //       selectedFarmerIds.includes(f.id)
  //     );
  //     localStorage.setItem(STORAGE_KEY, JSON.stringify(selectedFarmerIds));
  //     localStorage.setItem(
  //       "selectedFarmersDetails",
  //       JSON.stringify(selectedFarmers)
  //     );
  //   } else {
  //     localStorage.removeItem(STORAGE_KEY);
  //     localStorage.removeItem("selectedFarmersDetails");
  //   }
  // }, [selectedFarmerIds]);
  const filterDataBasedId = (item) => {
    setSelectedFarmerIds(item);
  };
  const CustomPagination = () => {
    return (
      <Pagination
        color="primary"
        count={pagination?.pageCount}
        page={pagination?.page}
        onChange={(event, value) => {
          setPagination({
            page: value,
            pageCount: pagination?.pageCount,
            perPage: pagination.perPage,
          });
        }}
        variant="outlined"
        shape="rounded"
      />
    );
  };
  return (
    <div className="container mt-4">
      {/* {!showConfirmation ? ( */}
      <>
        <div className="mb-4 d-flex gap-3 flex-wrap text-center justify-content-center">
          {["Saathi", "FPO", "CBBO"].map((role) => (
            <Button
              key={role}
              style={{ minWidth: 240 }}
              variant={selectedRole === role ? "warning" : "outline-warning"}
              onClick={() => {
                setSelectedRole(role);
                setSelectedUser(null);
              }}
            >
              Assign {role}
            </Button>
          ))}
        </div>

        <Row className="align-items-start mb-4">
          <Col md={4}>
            <Form.Group controlId="userDropdown">
              <Form.Label>
                <strong>Select {selectedRole}</strong>
              </Form.Label>
              {saathiLoading || fpoLoading || cbboLoading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <Form.Select
                  value={selectedUser?.id || ""}
                  onChange={(e) => {
                    const user = userList.find((u) => u.id === e.target.value);
                    setSelectedUser(user);
                  }}
                >
                  <option value="">-- Select {selectedRole} --</option>
                  {userList.map((user) => (
                    <option key={user.id} value={user.id}>
                      {selectedRole === "Saathi"
                        ? user.full_name
                        : user.organization_name}
                    </option>
                  ))}
                </Form.Select>
              )}
            </Form.Group>
          </Col>

          {selectedUser && (
            <Col md={7}>
              <Card
                className="p-3 rounded-3 mx-5"
                style={{ marginBottom: "0px", border: "1px dashed orange" }}
              >
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <Image
                      src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                      roundedCircle
                      width={40}
                      height={40}
                      className="me-2"
                      alt="Profile"
                    />
                    <div>
                      <strong>
                        {selectedRole === "Saathi"
                          ? selectedUser.full_name
                          : selectedUser.organization_name}
                      </strong>
                    </div>
                  </div>
                  <div className="text-end" style={{ fontSize: "0.9rem" }}>
                    <div>
                      <strong>Phone:</strong> {selectedUser.phone_number || "-"}
                    </div>
                    <div>
                      <strong>{selectedRole !== "Saathi" && "Email:"}</strong>
                      {(selectedRole !== "Saathi" && selectedUser.email) || "-"}
                    </div>
                  </div>
                </div>
              </Card>
            </Col>
          )}
        </Row>
        <Row style={{ backgroundColor: "#f8f8f8" }}>
          <Col md={2} className="mt-3">
            <CustomSearchBar sendSearchFunction={handleChangeSearch} />
          </Col>
          <Col md={10}>
            <StateDistrict
              onLocationChange={onLocationChange}
              state_id={state_id}
              district_id={district_id}
              block_id={block_id}
              stateName={stateName}
              districtName={districtName}
              blockName={blockName}
              setBlockList={setBlockList}
              blockList={blockList}
              noBlock={true}
              setStateName={setStateName}
              setDistrictName={setDistrictName}
              setStateId={setStateId}
              setDistrictId={setDistrictId}
            />
          </Col>
        </Row>

        <div className="d-flex justify-content-between align-items-center my-3">
          <h5>Select Farmers</h5>
          <Button variant="success" onClick={handleSubmit}>
            Submit
          </Button>
        </div>
        {farmerLoading ? (
          <div className="d-flex flex-column justify-content-center align-items-center py-5">
            <Spinner
              animation="border"
              variant="primary"
              role="status"
              style={{ width: "2rem", height: "2rem" }}
            >
              <span className="visually-hidden">Loading...</span>
            </Spinner>
            <div className="mt-3">
              <strong>Loading farmer data...</strong>
            </div>
          </div>
        ) : (
          <DataGrid
            rows={farmerRows}
            columns={columns}
            rowsPerPageOptions={[3]}
            checkboxSelection
            keepNonExistentRowsSelected
            onRowSelectionModelChange={(item) => {
              filterDataBasedId(item);
            }}
            components={{
              Pagination: CustomPagination,
            }}
          />
        )}
      </>
      {/* ) : (
        <>
          <h5 className="mb-3">Confirm Selected Farmers</h5>
          <Row className="mb-4">
            {submittedFarmers.map((farmer) => (
              <Col key={farmer.id} md={6} lg={3} className="mb-2">
                <Card className="shadow-sm  border-0 rounded-3">
                  <Card.Body className="p-3">
                    <div className="d-flex align-items-center mb-3">
                      <Image
                        src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                        roundedCircle
                        width={40}
                        height={40}
                        className="me-2"
                        alt="Farmer"
                      />
                      <div>
                        <Card.Title className="mb-0">
                          {farmer.full_name}
                        </Card.Title>
                        <small className="text-muted">
                          {farmer.phone_number}
                        </small>
                      </div>
                    </div>
                    <div className="mb-1">
                      <strong>Gender:</strong> {farmer.gender || "-"}
                    </div>
                    <div className="mb-1">
                      <strong>Age:</strong> {farmer.age || "-"}
                    </div>
                    <div className="mb-1">
                      <strong>State:</strong> {farmer.state_name || "-"}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          <div className="d-flex gap-3">
            <Button
              variant="secondary"
              onClick={() => setShowConfirmation(false)}
            >
              Back
            </Button>
            <Button variant="success" onClick={handleFinalSubmit}>
              Submit Farmers
            </Button>
          </div>
        </>
      )
      } */}
    </div>
  );
};
